<app-question-card>
  <p question>Are the common areas in the home painted in neutral colors?</p>
  <div class="form-field" input-options>
    <div class="radio-option-circle" *ngFor="let option of options">
      <input type="radio" [id]="option" name="neutral-color" [value]="option" [(ngModel)]="selectedOption" />
      <label [for]="option" class="basement-yes"> {{labels[option]}} </label>
    </div>
  </div>
  <p class="chat-answer" answer>{{ labels[selectedOption!] }}</p>
  <button class="w-100" footer [disabled]="!selectedOption" (click)="next()">Continue</button>
</app-question-card>
